import { createAction } from '@reduxjs/toolkit';

const registerRequest = createAction('auth/registerRequest');
const registerSuccess = createAction('auth/registerSuccess');
const registerError = createAction('auth/registerError');

const loginRequest = createAction('auth/loginRequest');
const loginSuccess = createAction('auth/loginSuccess');
const loginError = createAction('auth/loginError');

const logoutRequest = createAction('auth/logoutRequest');
const logoutSuccess = createAction('auth/logoutSuccess');
const logoutError = createAction('auth/logoutError');

const getCurrentUserRequest = createAction('auth/getCurrentUserRequest');
const getCurrentUserSuccess = createAction('auth/getCurrentUserSuccess');
const getCurrentUserError = createAction('auth/getCurrentUserError');

const googleAuthRequest = createAction('auth/googleAuthRequest');
const googleAuthSuccess = createAction('auth/googleAuthSuccess');
const googleAuthError = createAction('auth/googleAuthError');

const clearToken = createAction('auth/clearToken');

const setToken = createAction('auth/setToken');

const unsetError = createAction('auth/unsetError');

export default {
  clearToken,
  registerRequest,
  registerSuccess,
  registerError,
  loginRequest,
  loginSuccess,
  loginError,
  logoutRequest,
  logoutSuccess,
  logoutError,
  getCurrentUserRequest,
  getCurrentUserSuccess,
  getCurrentUserError,
  googleAuthRequest,
  googleAuthSuccess,
  googleAuthError,
  unsetError,
  setToken,
};
